export default __webpack_public_path__ + "static/media/worker-with-bb.c6ef58f4.png";